// Only this admin can view the Update Activity log (Auth_Users below).
export const SUPER_ADMIN_EMAIL = "prateekshukla130@gmail.com";

export const Auth_Users = [
  {
    type: "admin",
    name: "Prateek",
    email: "prateekshukla130@gmail.com",
    password: "Prateek@120966",
    permissions: {
      donation: { read: true, update: true, delete: true, create: true },
      expense: { read: true, update: true, delete: true, create: true },
    },
  },
  {
    type: "admin",
    name: "Surendra",
    email: "usernavratri1@gmail.com",
    password: "Surendra@88188",
    permissions: {
      donation: { read: true, update: true, delete: true, create: true },
      expense: { read: true, update: true, delete: true, create: true },
    },
  },
  {
    type: "admin",
    name: "Aman",
    email: "usernavratri2@gmail.com",
    password: "Aman@626016",
    permissions: {
      donation: { read: true, update: true, delete: true, create: true },
      expense: { read: true, update: true, delete: true, create: true },
    },
  },
];
